export enum PosterEditingTranscriptOptionsSubPanel {
  NONE = 'none',
  CUSTOMIZE = 'customize',
  TEMPLATES = 'templates',
}
